import * as React from "react";

type PropsChangeFlag = {
  changed: boolean;
};

export const ChangeFlag: React.FC<PropsChangeFlag> = ({ changed }) =>
  changed ? "*" : null;
